import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";

const AccountUpdateServiceOverview = ({ data }) => {
  const {
    cn_automatic_account_updater_service_mastercard_automatic_billing_updater,
    cn_automatic_account_updater_service_visa_account_updater,
  } = data["2_4"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading
            title="Automatic Account Updater Service"
          />
        </div>
        <ReviewAttribute
          label="Would you like to enable MasterCard Automatic Billing Updater (ABU) service for your cardholders?"
          value={
            cn_automatic_account_updater_service_mastercard_automatic_billing_updater?.length
              ? toTitleCase(cn_automatic_account_updater_service_mastercard_automatic_billing_updater)
              : "-"
          }
        />
        <ReviewAttribute
          label="Would you like to enable Visa Account Updater (VAU) service for your cardholders?"
          value={
            cn_automatic_account_updater_service_visa_account_updater?.length
              ? toTitleCase(cn_automatic_account_updater_service_visa_account_updater)
              : "-"
          }
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default AccountUpdateServiceOverview;
